// Gargi runs only on the business's own AI provider keys. api-server refuses a Gargi request with
// 412 and this code when the business has none; every Gargi surface uses these to point the user to
// the settings page instead of showing a generic error.
export const GARGI_SETTINGS_PATH = '/settings/modules/gargi';
export const PROVIDER_KEY_REQUIRED = 'GARGI_PROVIDER_KEY_REQUIRED';
export const PROVIDER_KEY_REQUIRED_MESSAGE =
  'Gargi needs an AI provider API key for this business. Add one in Settings → Modules → Gargi.';

export const isProviderKeyRequired = (error: unknown): boolean =>
  (error as any)?.response?.data?.code === PROVIDER_KEY_REQUIRED;

// The message a request failure should show: the server's own words when it sent any.
export const errorMessage = (error: unknown, fallback: string): string =>
  (error as any)?.response?.data?.message || fallback;
